"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSharedConfig = exports.DEFAULT_LAYOUT_CONFIG = void 0;
// Used in Math and Matrix-reasoning so far
const omitBy_1 = __importDefault(require("lodash/omitBy"));
const isNull_1 = __importDefault(require("lodash/isNull"));
const isUndefined_1 = __importDefault(require("lodash/isUndefined"));
const i18next_1 = __importDefault(require("i18next"));
const isRoarApp_1 = require("./isRoarApp");
const camelize_1 = require("./camelize");
const getAge_1 = require("./getAge");
const parseParam_1 = require("./parseParam");
const clowderSetup_1 = require("./clowderSetup");
exports.DEFAULT_LAYOUT_CONFIG = {
    playAudioOnLoad: true,
    staggered: {
        enabled: false,
        trialTypes: [],
    },
    classOverrides: {
        buttonContainerClassList: ['lev-response-row', 'multi-4'],
        buttonClassList: ['image'],
        promptClassList: ['lev-row-container', 'instruction'],
        stimulusContainerClassList: ['lev-stim-content-x-3'],
    },
    prompt: {
        enabled: true,
        aboveStimulus: true,
    },
    equalSizeStim: false,
    disableButtonsWhenAudioPlaying: false,
    isPracticeTrial: false,
    isInstructionTrial: false,
    randomizeChoiceOrder: false,
    isStaggered: false,
    isImageButtonResponse: false,
    showStimImage: true,
    response: {
        target: '',
        displayValues: ['OK'],
        values: ['OK'],
        targetIndex: 0,
    },
    inCorrectTrialConfig: {
        onIncorrectTrial: 'end',
    },
    disableOkButton: false,
};
const defaultCorpus = {
    egmaMath: 'math-item-bank',
    matrixReasoning: 'matrix-reasoning-item-bank',
    mentalRotation: 'mental-rotation-item-bank',
    sameDifferentSelection: 'same-different-selection-item-bank',
    trog: 'roar-syntax-item-2026-05-14-v3',
    theoryOfMind: 'theory-of-mind-item-bank',
    vocab: 'vocab-item-bank',
    roarInference: 'inference-2026-05-14-v3',
    adultReasoning: 'adult-reasoning-item-bank',
    hostileAttribution: 'hostile-attribution-item-bank',
    childSurvey: 'child-survey-item-bank',
};
const setSharedConfig = async (firekit, gameParams, userParams) => {
    const cleanParams = (0, omitBy_1.default)((0, omitBy_1.default)({ ...gameParams, ...userParams }, isNull_1.default), isUndefined_1.default);
    const { userMetadata = {}, birthMonth, birthYear, audioFeedback, language, skipInstructions, sequentialPractice, sequentialStimulus, corpus, buttonLayout, numberOfTrials, taskName, stimulusBlocks, numOfPracticeTrials, maxIncorrect, keyHelpers, age, maxTime, // maximum app duration in minutes
    storeItemId, cat, heavyInstructions, experimenterButtons, inferenceNumStories, numberOfStories, semThreshold, startingTheta, storyOption, grade, demoMode, debug, version, taskVersion, // deprecated; use `version` — kept for backward compatibility
    isPaused, scoringVersion, randomSeed, } = cleanParams;
    const numScoringVersion = Number(scoringVersion);
    const config = {
        userMetadata: {
            ...userMetadata,
            grade,
            age: Number(age) || (0, getAge_1.getAge)(Number(birthMonth), Number(birthYear)),
            birthMonth,
            birthYear,
        },
        audioFeedback: audioFeedback || 'neutral',
        skipInstructions: !!skipInstructions, // Not used in any task
        startTime: new Date(),
        firekit,
        sequentialPractice: sequentialPractice !== null && sequentialPractice !== void 0 ? sequentialPractice : true,
        sequentialStimulus: sequentialStimulus !== null && sequentialStimulus !== void 0 ? sequentialStimulus : true,
        // name of the csv files in the storage bucket
        corpus: corpus,
        buttonLayout: buttonLayout || 'default',
        numberOfTrials: numberOfTrials !== null && numberOfTrials !== void 0 ? numberOfTrials : 300,
        task: taskName !== null && taskName !== void 0 ? taskName : 'egma-math',
        stimulusBlocks: Number(stimulusBlocks) || 1,
        numOfPracticeTrials: Number(numOfPracticeTrials) || 2,
        maxIncorrect: Number(maxIncorrect) || 3,
        keyHelpers: !!keyHelpers,
        language: language !== null && language !== void 0 ? language : i18next_1.default.language,
        maxTime: Number(maxTime) || 100,
        storeItemId: !!storeItemId,
        isRoarApp: (0, isRoarApp_1.isRoarApp)(firekit),
        cat: !!cat, // defaults to false
        heavyInstructions: !!heavyInstructions,
        experimenterButtons: !!experimenterButtons,
        inferenceNumStories: (0, parseParam_1.parseNumberParam)(inferenceNumStories, 33),
        numberOfStories: Number(numberOfStories) || 3,
        semThreshold: Number(semThreshold),
        startingTheta: Number(startingTheta),
        storyOption,
        demoMode: false,
        debug: !!debug,
        version: Number((version !== null && version !== void 0 ? version : taskVersion) || 1),
        displayPromptDurations: {},
        taskTimer: null,
        isPaused: false,
        // Default to normed for clowder tasks. Pass scoringVersion=0 to use unnormed
        scoringVersion: scoringVersion != null && !isNaN(numScoringVersion) ? numScoringVersion : clowderSetup_1.CLOWDER_CONFIG[taskName] ? 1 : 0,
        randomSeed,
    };
    // default corpus if nothing is passed in
    if (!config.corpus) {
        config.corpus = defaultCorpus[(0, camelize_1.camelize)(taskName)];
    }
    const updatedGameParams = Object.fromEntries(Object.entries(gameParams).map(([key, value]) => { var _a; return [key, (_a = config[key]) !== null && _a !== void 0 ? _a : value]; }));
    await config.firekit.updateTaskParams(updatedGameParams);
    return config;
};
exports.setSharedConfig = setSharedConfig;
